import React from 'react';
import { css } from 'linaria';

import Colors from '../../../constants/Colors';
import { Text, Link } from '../../../components/core';

export default function Banner() {
  return (
    <div className={ContainerStyles}>
      <Text color={Colors.White} weight="bold" style={{ verticalAlign: 'middle', marginLeft: 8 }}>
        Now live in New York City! Starting today, Luggers are hitting the pavement -{' '}
        <Link className={LinkStyles} to="/cities/new-york-city">
          learn more.
        </Link>
      </Text>
    </div>
  );
}

const ContainerStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Colors.Violet};
  margin: 0 auto;
  text-align: center;
  border-radius: 40px;
  padding: 12px;
  margin-top: 20px;
  border: 2px solid ${Colors.darken(Colors.Violet, 0.1)};
`;

const LinkStyles = css`
  color: ${Colors.White};
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/ui/pages/HomePage/components/Banner.js